import { Color, Spacing } from '@persona-id/design-tokens';
import { noop } from 'lodash/fp';
import styled from 'styled-components';

import { REACT_SELECT_PORTAL_ID_PREFIX } from 'dashboard/components/WorkflowControlPanel/TriggerConfigCase/TriggerCaseParamSchemaEditor';
import FormCaseAction from 'dashboard/forms/FormCaseAction';
import { CaseActionWorkflow } from 'dashboard/models/case';
import { TriggerCase } from 'dashboard/models/trigger';
import Spacer from 'design-system/components/Spacer';
import Sticker from 'design-system/components/Sticker';
import { Heading } from 'design-system/components/Text';

const PreviewHeader = styled.div`
  margin: 0;
  padding-bottom: ${Spacing[5]};
`;

const PreviewContainer = styled.div`
  padding: 0px 10%;
  display: flex;
  flex-direction: column;
  max-height: 100%;
  overflow: auto;
`;

const PreviewBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 100%;
`;

const StyledSticker = styled(Sticker)`
  width: fit-content;
  border: 1px solid ${Color.CorePurple200};
`;

interface TriggerCaseInputModalPreviewProps {
  trigger: TriggerCase;
  workflowName: string;
}

const TriggerCaseInputModalPreview = ({
  trigger,
  workflowName,
}: TriggerCaseInputModalPreviewProps) => {
  const isSchemaEmpty = trigger.attributes['param-schema'].length === 0;
  return (
    <PreviewContainer>
      <StyledSticker variant='primary'>Preview</StyledSticker>
      <Spacer height={2} />
      {isSchemaEmpty ? (
        <>
          <h3>Looks like there aren&#39;t any input fields yet.</h3>
          <p>Create an input field to get started.</p>
        </>
      ) : (
        <PreviewBodyContainer data-test='trigger-case-input-modal-preview'>
          <PreviewHeader data-test='trigger-case-input-modal-preview-header'>
            <Heading size='md'>{workflowName}</Heading>
          </PreviewHeader>
          <FormCaseAction
            caseAction={
              {
                workflow: { id: REACT_SELECT_PORTAL_ID_PREFIX },
                trigger: trigger,
              } as CaseActionWorkflow
            }
            onSubmit={noop}
            handleCancel={noop}
            initialValues={{}}
          />
        </PreviewBodyContainer>
      )}
    </PreviewContainer>
  );
};

export default TriggerCaseInputModalPreview;
